export enum GeoFenceType {
    CIRCLE = "circle",
    POLYGON = "polygon" 
};

export enum GeoFenceAlertTrigger {
    ENTER = "inFence",
    EXIT = "outFence",
    BOTH = "changeFence"
};

export type GeoFencePoint = {
  lat: number;
  lng: number;
};

export type CircleFence = {
  center: GeoFencePoint;
  radius: number;
};

export type PolygonFence = {
  coordinates: GeoFencePoint[];
};

export interface GeoFenceRequestBody {
    id?: string;
    name: string;
    geoFenceType: GeoFenceType;
    geoFenceEntryDetected: GeoFenceAlertTrigger;
    geoFenceData: CircleFence | PolygonFence;
}